module.exports = __webpack_public_path__ + "img/DDosSection.67ad8c8.svg";